import {createApp} from 'vue'
import NotificationList from './NotificationList'

const el = '.kb-component--notification-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((NotificationListDOM) => {
            const props = {
                skip: parseInt(NotificationListDOM.dataset.skip) ?? 0,
                take: parseInt(NotificationListDOM.dataset.take) ?? 10
            }
            const component = createApp(NotificationList, props).use(Store)
            component.mount(NotificationListDOM)
        })
    }
}